import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="route-error" data-testid="route-error-state">
          <h1>We couldn’t open this workspace view.</h1>
          <p>Please return to your dashboard and try again.</p>
          <a className="primary-button" href="/app" data-testid="return-dashboard-link">
            Return to dashboard
          </a>
        </main>
      );
    }
    return this.props.children;
  }
}